import MixpanelService from 'services/mixpanel/mixpanel-service';
import { MixpanelWrapperInstance } from 'services/mixpanel/mixpanel-wrapper';
import { EventNames } from 'services/mixpanel/provider-app-mixpanel-events';
import { ProviderAppMixpanelInstance } from 'services/mixpanel/provider-app-mixpanel-service';
import { RpmEventTrackingService } from 'services/rpm/rpm-track-event-service';

export type SignInTrackingProps = {
  uuid: string;
  userId: number;
  roles?: { name: string }[];
};

/** The tracking every sign-in does, whichever way the user signed in. */
export const trackSignIn = ({ uuid, userId, roles }: SignInTrackingProps): void => {
  const roleNames = roles?.map((role) => role.name) || [];

  MixpanelService.identify(uuid);
  MixpanelService.set({ Roles: roleNames, userId });
  // Tracking to shared Mixpanel
  ProviderAppMixpanelInstance.identify(uuid);
  ProviderAppMixpanelInstance.set({ roles: roleNames });

  MixpanelWrapperInstance.track(EventNames.SessionLogIn);
  RpmEventTrackingService.setDefaultValues({ providerUuid: uuid });
};
